export enum FORM_CONTROLS {
  EMAIL= 'email',
  PASSWORD = 'password',
  REMEMBER_ME = 'rememberMe'
}
